module.exports = __webpack_public_path__ + "static/media/266.41c2ec1b.svg";